import { orderRepository } from '@webapp/modules/purchasing/data-access/repositories/OrderRepository'
import { CheckHasOrderWatchlistUseCase } from './CheckHasOrderWatchlistUseCase'

export const checkHasOrderWatchlistUseCase = new CheckHasOrderWatchlistUseCase({
  orderRepository,
}).execute
